var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowMore = function SvgArrowMore(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 19 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18.03 6.53a.75.75 0 0 0 0-1.06L13.257.697a.75.75 0 0 0-1.06 1.06L16.439 6l-4.242 4.243a.75.75 0 0 0 1.06 1.06zM0 6v.75h17.5v-1.5H0z"
  })));
};
export default SvgArrowMore;